module.exports = __webpack_public_path__ + "static/img/wx01.2defb343.png";